<template>
  <v-dialog width="500px" :value="showNewEditPromotorDialog" @input="resetNewPromotor" persistent scrollable>
    <v-card class="kbLight">
      <v-toolbar class="kbGold" dark text flat>
        <div class="text-h6">{{ methodNewEditPromotor === 'edit' ? $t('general.edit') : $t('general.new')}} {{$t('general.promoter')}}</div>
        <v-spacer></v-spacer>
        <v-btn icon @click="resetNewPromotor">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-form v-model="validUser" ref="newEditUserForm" lazy-validation>
          <v-row>
            <v-col cols="12">
              <v-text-field :label="$t('general.name')"
                            color="kbDarkBlue"
                            :rules="[rules.required]"
                            v-model="newEditPromotorObj.name"
                            autofocus
                            :readonly="appUserWasAlreadyCreated"/>
            </v-col>

            <v-col cols="12" v-if="!appUserWasAlreadyCreated">
              <CountryPhonePicker :value="countryPhonePicker" @input="setCountryPhone"/>
            </v-col>

            <v-col cols="12">
              <v-text-field label="Email"
                            color="kbDarkBlue"
                            :rules="[rules.required]"
                            v-model="newEditPromotorObj.email"
                            @keyup.enter="submit"
                            :readonly="appUserWasAlreadyCreated"
              />
            </v-col>

            <v-col cols="12" v-if="!appUserWasAlreadyCreated">
              <v-text-field :label="$t('general.password')"
                            color="kbDarkBlue"
                            v-model="newEditPromotorObj.password"
                            @keyup.enter="submit"
                            type="password"
                            :rules="[rules.required, rules.min8]"/>
            </v-col>

            <v-col cols="12">
              <v-text-field :label="$t('general.status')"
                            color="kbDarkBlue"
                            v-model="newEditPromotorObj.status"
                            @keyup.enter="submit"/>
            </v-col>

            <v-col cols="12">
              <v-text-field label="Ranking"
                            color="kbDarkBlue"
                            v-model="newEditPromotorObj.ranking"
                            @keyup.enter="submit"/>
            </v-col>

            <v-col cols="12">
              <v-text-field :label="$t('general.location')"
                            color="kbDarkBlue"
                            v-model="newEditPromotorObj.location"
                            @keyup.enter="submit"/>
            </v-col>

            <v-col cols="12">
              <v-text-field :label="$t('general.locationUrl')"
                            color="kbDarkBlue"
                            v-model="newEditPromotorObj.locationUrl"
                            @keyup.enter="submit"/>
            </v-col>

            <v-col cols="12">
              <v-text-field :label="$t('general.facebookMessageSendingUrl')"
                            color="kbDarkBlue"
                            v-model="newEditPromotorObj.fbSendMessageUrl"
                            @keyup.enter="submit"/>
            </v-col>

            <v-col cols="12">
              <v-text-field :label="$t('general.facebookSiteUrl')"
                            color="kbDarkBlue"
                            v-model="newEditPromotorObj.fbProfileUrl"
                            @keyup.enter="submit"/>
            </v-col>

            <!-- <v-flex xs12>
              <v-text-field label="Url a la página del promotor"
                            v-model="newEditPromotorObj.webUrl"
                            @keyup.enter="submit"
              />
            </v-flex> -->

            <HtmlEditor v-model="newEditPromotorObj.rawHtml"/>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="mr-2" color="red" outlined @click="resetNewPromotor">{{$t('general.cancel')}}</v-btn>
        <v-btn color="kbGold"
               dark
               @click="submit"
               :loading="loadingSubmitNewUpdatePromotor">
            {{ methodNewEditPromotor === 'edit' ? $t('general.edit'): $t('general.create')}} {{$t('general.promoter')}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import notifications from '@/libs/notifications'
import rules from '@/libs/rules'
import CountryPhonePicker from '@/components/ui/CountryPhonePicker'
import HtmlEditor from '@/components/ui/HtmlEditor'
export default {
  components: { CountryPhonePicker, HtmlEditor },
  computed: {
    ...mapState({
      loadingSubmitNewUpdatePromotor: state => state.events.loadingSubmitNewUpdatePromotor,
      selectedApp: state => state.apps.selectedApp,
      methodNewEditPromotor: state => state.events.methodNewEditPromotor
    }),
    newEditPromotorObj: {
      get () {
        return this.$store.state.events.newEditPromotorObj
      },
      set (value) {
        this.$store.commit('SET_NEW_EDIT_PROMOTOR_OBJ', value)
      }
    },
    appUserWasAlreadyCreated () {
      return !!(this.newEditPromotorObj &&
          this.newEditPromotorObj.userId)
    },
    showNewEditPromotorDialog: {
      get () {
        return this.$store.state.events.showNewEditPromotorDialog
      },
      set (value) {
        this.$store.commit('SET_SHOW_NEW_EDIT_PROMOTOR_DIALOG', value)
      }
    }
  },
  data () {
    return {
      validUser: false,
      rules,
      countryPhonePicker: {
        country: 'Colombia',
        code: 'co',
        number: '57',
        phone: ''
      }
    }
  },
  methods: {
    async submit () {
      try {
        if (await !this.$refs.newEditUserForm.validate()) return notifications.error(this.$t('general.completeRequiredFields'))
        if (this.methodNewEditPromotor === 'new') {
          const response = await this.$store.dispatch('createPromotor')
          if (response) {
            notifications.success(this.$t('general.promoterSuccessfullyCreated'))
            this.resetNewPromotor()
            // TODO: ask if method was create and emit event to open modal upload profile photo
          }
        }
        if (this.methodNewEditPromotor === 'edit') {
          const response = await this.$store.dispatch('updatePromotor')
          if (response) {
            notifications.success(this.$t('general.promoterSuccessfullyUpdated'))
            this.resetNewPromotor()
          }
        }
      } catch (error) {
        console.error(error)
      }
    },
    resetNewPromotor () {
      this.$refs.newEditUserForm.reset()
      this.showNewEditPromotorDialog = !this.showNewEditPromotorDialog
    },
    setCountryPhone (data) {
      this.countryPhonePicker = data

      this.newEditPromotorObj.phone = data.phone
      this.newEditPromotorObj.country = data.code
      this.newEditPromotorObj.countryCode = data.number
    }
  },
  watch: {
    showNewEditPromotorDialog: {
      handler (value) {
        if (!value) {
          this.newEditPromotorObj = {}
        }
      },
      deep: true
    }
  }
}
</script>
